<ng-container *ngFor="let warning of maxHoursWarnings">
    <ui-banner class="banner margin-bottom-2 align-left" variant="danger">
        <p
            *ngIf="enteringFor === 'self'"
            [innerHTML]="
                { key: 'time-tracking.enterHoursPage.errorMessage24HoursSelf', params: { date: warning.localeDate } }
                    | appTranslate
                    | sanitizeHtml
            "
        ></p>
        <p
            *ngIf="enteringFor !== 'self'"
            [innerHTML]="
                {
                    key: 'time-tracking.enterHoursPage.errorMessage24HoursOther',
                    params: { employeeName: warning.employeeName, date: warning.localeDate },
                }
                    | appTranslate
                    | sanitizeHtml
            "
        ></p>
    </ui-banner>
</ng-container>

<ng-container *ngFor="let error of overlapErrors">
    <ui-banner class="banner margin-bottom-2 align-left" variant="danger">
        {{ error }}
    </ui-banner>
</ng-container>

<ui-banner *ngIf="editBanners.employeeRemovedFromTimeTracking" class="banner margin-bottom-2 align-left" variant="info">
    <p>{{ 'time-tracking.enterHoursPage.employeeRemovedFromTimeTracking' | appTranslate }}</p>
</ui-banner>
<ui-banner *ngIf="editBanners.employeeRemovedFromProject" class="banner margin-bottom-2 align-left" variant="info">
    <p
        [innerHTML]="
            {
                key: 'time-tracking.enterHoursPage.employeeRemovedFromProject',
                params: { project: timesheetEntries[0].project?.name },
            }
                | appTranslate
                | sanitizeHtml
        "
    ></p>
</ui-banner>
<ui-banner *ngIf="editBanners.projectArchived" class="banner margin-bottom-2 align-left" variant="info">
    <p
        [innerHTML]="
            {
                key: 'time-tracking.enterHoursPage.projectArchived',
                params: { project: timesheetEntries[0].project?.name },
            }
                | appTranslate
                | sanitizeHtml
        "
    ></p>
</ui-banner>

<ng-container *ngFor="let timesheetEntry of timesheetEntries; let i = index">
    <app-enter-hours-card
        #entryCards
        [timesheetEntry]="timesheetEntry"
        [employees]="employees"
        [enteringFor]="enteringFor"
        [defaultApprovalFlow]="defaultApprovalFlow"
        [companyIsOnPayrollIntegration]="companyIsOnPayrollIntegration"
        [showRemove]="editMode ? false : timesheetEntries.length > 1"
        [projectCanBeChanged]="projectCanBeChanged"
        [overlappingEntries]="overlapFieldErrors[i] || { start: [], end: [] }"
        (onRemoveEntry)="removeEntry(i)"
        (onChangeEmployeeOrWorkedOn)="onChangeEmployeeOrWorkedOn($event)"
        (onChangeMinutes)="onChangeMinutes()"
        [attr.data-cy]="'enter-hours-card-' + i"
    ></app-enter-hours-card>
</ng-container>
<div class="flex" [ngClass]="editMode ? 'justify-end' : 'justify-space-between'">
    <ui-button *ngIf="!editMode" (click)="onAddTimeEntry()" class="buttons" type="outline"
        ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-tracking.enterHoursPage.addEntry' | translate }}
    </ui-button>
    <div class="flex">
        <ui-button (click)="onBack()" class="buttons" type="ghost">{{ 'cancel' | translate }} </ui-button>
        <ui-button
            (click)="onClickSave()"
            [disabled]="!valid || maxHoursWarnings.length > 0"
            class="buttons"
            type="primary"
            >{{ 'save' | translate }}
        </ui-button>
    </div>
</div>
